export default "__VITE_ASSET__CCI_79XC__"